import styled from '@emotion/styled';

export const Select = styled.select`
  width: 100%;
  padding: 2px;
  border-radius: 4px;
  border: 1px solid #ddd;
  ${({ hasError, theme }) =>
    hasError &&
    `
    background-color: ${theme.colors.backgroundDanger};
    border-color: ${theme.colors.borderDanger};
  `}
`;
